/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-12 15:40:50                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-12 17:07:05                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * UnasignedDrawer: display unasigned drawer
*/

/* Imports */
import { Typography } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
/***/

/* Components */
import WorkorderDashCard from "../../../components/data/workorder/WorkorderDashCard";
/***/

/**
* UnasignedDrawer: display unasigned drawer
* @param times - times to display 
*/
export default function UnasignedDrawer({
  workorders = [],
  onTimeClick
}: {
  workorders: EasyTech.Workorder[],
  onTimeClick: (el: EasyTech.Workorder) => void
}) {
  const { t } = useTranslation();

  return(
    <div>
        <Typography variant="h5">{t("planification:calendar:unasigned:title")}</Typography>

        <div className="flex flex-col gap-2 mt-3">
          {workorders.map((el,i) => <WorkorderDashCard workorder={el} onClick={() => onTimeClick(el)} key={"unasigned-inter-"+i} />)}
          {workorders.length === 0 && <i>{t("planification:calendar:unasigned:noData")}</i>}
        </div>
    </div>
  );
}
/***/
